import React, {useMemo} from 'react';
import {
  invalidateBootstrapData,
  mergeBootstrapData,
  setBootstrapData,
  useBackendBootstrapData,
} from './use-backend-bootstrap-data';
import {
  BoostrapDataContext,
  BoostrapDataContextValue,
} from './bootstrap-data-context';
import {ModalBody} from "@common/ui/modal-body";
import {RunningWithErrorsIcon} from "@common/icons/material/RunningWithErrors";
import {CancelIcon} from "@common/icons/material/Cancel";
import {Trans} from "@common/i18n/trans";
import {Modal} from "@common/ui/modal";

interface BootstrapDataProviderProps {
  children: any;
}
export function BootstrapDataProvider({children}: BootstrapDataProviderProps) {
  const {data} = useBackendBootstrapData();
  const maintenanceModal = data?.user?.maintenance
    ? (
      <Modal title={"Maintenance"} closeModal={()=>{}} showClose={false}>
        <ModalBody isLoading={false}
                   title={"Maintenance"}
                   icon={<RunningWithErrorsIcon color={'rgb(36, 101, 181)'} size={'icon-lg'}/>}>
          <Trans message={"We’re currently performing maintenance on your account to improve your experience. Thank you for your patience! "} />
          <Trans message={"Expected completion time: "+data?.user?.maintenance_finish_date} />
        </ModalBody>
      </Modal>
    ) : (<></>);

  const value: BoostrapDataContextValue = useMemo(() => {
    return {
      data: data,
      setBootstrapData: setBootstrapData,
      mergeBootstrapData: mergeBootstrapData,
      invalidateBootstrapData: invalidateBootstrapData,
    };
  }, [data]);

  return (
    <BoostrapDataContext.Provider value={value}>
      {maintenanceModal}
      {children}
    </BoostrapDataContext.Provider>
  );
}
